/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { OperationsTaskType } from "./OperationsTaskType";
import {
  OperationsTaskTypeFromJSON,
  OperationsTaskTypeFromJSONTyped,
  OperationsTaskTypeToJSON,
  OperationsTaskTypeToJSONTyped,
} from "./OperationsTaskType";
import type { ConversationTurn } from "./ConversationTurn";
import {
  ConversationTurnFromJSON,
  ConversationTurnFromJSONTyped,
  ConversationTurnToJSON,
  ConversationTurnToJSONTyped,
} from "./ConversationTurn";
import type { OperationsTaskResolutionChannel } from "./OperationsTaskResolutionChannel";
import {
  OperationsTaskResolutionChannelFromJSON,
  OperationsTaskResolutionChannelFromJSONTyped,
  OperationsTaskResolutionChannelToJSON,
  OperationsTaskResolutionChannelToJSONTyped,
} from "./OperationsTaskResolutionChannel";

/**
 *
 * @export
 * @interface OperationsTask
 */
export interface OperationsTask {
  /**
   *
   * @type {string}
   * @memberof OperationsTask
   */
  operationsTaskId?: string;
  /**
   *
   * @type {string}
   * @memberof OperationsTask
   */
  shipmentId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof OperationsTask
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof OperationsTask
   */
  createdBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof OperationsTask
   */
  updatedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof OperationsTask
   */
  updatedBy?: string;
  /**
   *
   * @type {OperationsTaskType}
   * @memberof OperationsTask
   */
  operationsTaskType?: OperationsTaskType;
  /**
   *
   * @type {ConversationTurn}
   * @memberof OperationsTask
   */
  carrierConversationTurn?: ConversationTurn;
  /**
   *
   * @type {ConversationTurn}
   * @memberof OperationsTask
   */
  customerConversationTurn?: ConversationTurn;
  /**
   *
   * @type {boolean}
   * @memberof OperationsTask
   */
  monitoring?: boolean;
  /**
   *
   * @type {string}
   * @memberof OperationsTask
   */
  monitoringReason?: string;
  /**
   *
   * @type {string}
   * @memberof OperationsTask
   */
  frontConversationId?: string;
  /**
   *
   * @type {string}
   * @memberof OperationsTask
   */
  title?: string;
  /**
   *
   * @type {boolean}
   * @memberof OperationsTask
   */
  isDone?: boolean;
  /**
   *
   * @type {string}
   * @memberof OperationsTask
   */
  description?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof OperationsTask
   */
  closedAt?: OffsetDateTime;
  /**
   *
   * @type {number}
   * @memberof OperationsTask
   */
  timesOpened?: number;
  /**
   *
   * @type {OperationsTaskResolutionChannel}
   * @memberof OperationsTask
   */
  resolutionChannel?: OperationsTaskResolutionChannel;
  /**
   *
   * @type {string}
   * @memberof OperationsTask
   */
  resolutionDetail?: string;
}

/**
 * Check if a given object implements the OperationsTask interface.
 */
export function instanceOfOperationsTask(
  value: object,
): value is OperationsTask {
  return true;
}

export function OperationsTaskFromJSON(json: any): OperationsTask {
  return OperationsTaskFromJSONTyped(json, false);
}

export function OperationsTaskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationsTask {
  if (json == null) {
    return json;
  }
  return {
    operationsTaskId:
      json["operationsTaskId"] == null ? undefined : json["operationsTaskId"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
    updatedBy: json["updatedBy"] == null ? undefined : json["updatedBy"],
    operationsTaskType:
      json["operationsTaskType"] == null
        ? undefined
        : OperationsTaskTypeFromJSON(json["operationsTaskType"]),
    carrierConversationTurn:
      json["carrierConversationTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["carrierConversationTurn"]),
    customerConversationTurn:
      json["customerConversationTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["customerConversationTurn"]),
    monitoring: json["monitoring"] == null ? undefined : json["monitoring"],
    monitoringReason:
      json["monitoringReason"] == null ? undefined : json["monitoringReason"],
    frontConversationId:
      json["frontConversationId"] == null
        ? undefined
        : json["frontConversationId"],
    title: json["title"] == null ? undefined : json["title"],
    isDone: json["isDone"] == null ? undefined : json["isDone"],
    description: json["description"] == null ? undefined : json["description"],
    closedAt: json["closedAt"] == null ? undefined : json["closedAt"],
    timesOpened: json["timesOpened"] == null ? undefined : json["timesOpened"],
    resolutionChannel:
      json["resolutionChannel"] == null
        ? undefined
        : OperationsTaskResolutionChannelFromJSON(json["resolutionChannel"]),
    resolutionDetail:
      json["resolutionDetail"] == null ? undefined : json["resolutionDetail"],
  };
}

export function OperationsTaskToJSON(json: any): OperationsTask {
  return OperationsTaskToJSONTyped(json, false);
}

export function OperationsTaskToJSONTyped(
  value?: OperationsTask | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    operationsTaskId: value["operationsTaskId"],
    shipmentId: value["shipmentId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    updatedAt: value["updatedAt"],
    updatedBy: value["updatedBy"],
    operationsTaskType: OperationsTaskTypeToJSON(value["operationsTaskType"]),
    carrierConversationTurn: ConversationTurnToJSON(
      value["carrierConversationTurn"],
    ),
    customerConversationTurn: ConversationTurnToJSON(
      value["customerConversationTurn"],
    ),
    monitoring: value["monitoring"],
    monitoringReason: value["monitoringReason"],
    frontConversationId: value["frontConversationId"],
    title: value["title"],
    isDone: value["isDone"],
    description: value["description"],
    closedAt: value["closedAt"],
    timesOpened: value["timesOpened"],
    resolutionChannel: OperationsTaskResolutionChannelToJSON(
      value["resolutionChannel"],
    ),
    resolutionDetail: value["resolutionDetail"],
  };
}
